import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import "./i18n";
import DevAuthWrapper from "./layouts/DevAuthWrapper";

function App() {

  return (
    <DevAuthWrapper>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </DevAuthWrapper>
  )
}

export default App
